var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout l-default l-suave", class: _vm.classes },
    [
      !_vm.noHeader
        ? _c("k-site-header", { staticClass: "layout-header" })
        : _vm._e(),
      _c("w-go-down", {
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.goDown.apply(null, arguments)
          },
        },
      }),
      _c(
        "div",
        { staticClass: "layout-main" },
        [
          _c(
            "d-main-image",
            _vm._b(
              { on: { load: _vm.pageLoaded } },
              "d-main-image",
              { img: _vm.img, show: _vm.show },
              false
            )
          ),
          _c("div", { staticClass: "main-column" }, [
            _c(
              "div",
              {
                directives: [{ name: "bar", rawName: "v-bar" }],
                staticClass: "scroll",
              },
              [
                _c(
                  "div",
                  { staticClass: "inner" },
                  [
                    _c("k-hero"),
                    _c("k-main", { attrs: { title: _vm.title } }, [
                      _c("div", {
                        staticClass: "content",
                        domProps: {
                          innerHTML: _vm._s(_vm.content || _vm.caption),
                        },
                      }),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _c("div", { staticClass: "side-column" }, [_vm._t("default")], 2),
        ],
        1
      ),
      !_vm.noFooter
        ? _c("wp-footer", { staticClass: "layout-footer" })
        : _vm._e(),
      _c("overlay", { staticClass: "layout-overlay" }),
      _c("sidebar", { staticClass: "layout-sidebar", attrs: { pos: "left" } }),
      _c("sidebar", { staticClass: "layout-sidebar", attrs: { pos: "right" } }),
      _c("modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }